<survey [model]="surveyModel"></survey>

